<template>
  <div>
    <wc-data-box
      :title='header.title'
      :titleIcon='header.icon'
      :titleIconColor='header.iconColor'
      showEdit
      @edit='editBasics'
    >
      <wc-two-column-table
        :items='basics'
        @rowClick='editBasics'
      ></wc-two-column-table>
      <v-card-text>
        <v-badge inline :color='division.icon_color'></v-badge>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='header.title'
      :icon='header.icon'
      :iconColor='header.color'
      :disableButtons='!isFormValid'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid' ref='form'>
        <basics-form v-model='divisionCopy'></basics-form>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import BasicsForm from '../../components/forms/BasicsForm'
import _ from 'lodash'

export default {
  name: 'division-basics',
  props: {
    division: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    divisionCopy: {},
    showDialog: false
  }),
  computed: {
    header () {
      return this.$store.state.icons.dataBox.basics
    },
    basics () {
      let table = [
        { text: 'Name', value: this.division.division },
        { text: 'Company name', value: this.division.company_name },
        { text: 'GST number', value: this.division.gst_number },
        { text: 'Order', value: this.division.order },
        { text: 'Icon', value: this.division.icon },
        { text: 'Icon color', value: '' }
      ]
      return table
    }
  },
  methods: {
    editBasics () {
      this.divisionCopy = _.cloneDeep(this.division)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.divisionCopy)
      this.showDialog = false
    }
  },
  components: {
    'basics-form': BasicsForm
  }
}
</script>
